// Ô nhập tiền: hiện phân cách hàng nghìn, chỉ nhận số không âm, bàn phím số trên iPad
import React from 'react';

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  value: number;
  onChange: (value: number) => void;
  max?: number;
  invalid?: boolean;
}

const MoneyInput = React.forwardRef<HTMLInputElement, Props>(({ value, onChange, max, invalid, className = '', ...rest }, ref) => (
  <input
    ref={ref}
    type="text"
    inputMode="numeric"
    autoComplete="off"
    value={value ? new Intl.NumberFormat('vi-VN').format(value) : value === 0 ? '0' : ''}
    onChange={e => {
      const digits = e.target.value.replace(/\D/g, '').slice(0, 13);
      let n = digits ? Number(digits) : 0;
      if (max !== undefined) n = Math.min(n, max);
      onChange(n);
    }}
    onFocus={e => e.target.select()}
    className={`h-11 w-full rounded-lg border bg-white px-3 text-right text-base font-semibold text-slate-800 outline-none focus:ring-2 ${
      invalid ? 'border-red-400 focus:ring-red-200' : 'border-slate-300 focus:border-[#3e91ab] focus:ring-[#3e91ab]/20'
    } ${className}`}
    {...rest}
  />
));

MoneyInput.displayName = 'MoneyInput';
export default MoneyInput;
